import { lazy } from 'react';

export const providerRegistry: Record<string, ReturnType<typeof lazy>> = {
    '@dcentralexpedientedigital/pragmatic-play-dga': lazy(() =>
        import('@dcentralexpedientedigital/pragmatic-play-dga').then(
            ({ PragmaticPlayIntegration }) => ({
                default: PragmaticPlayIntegration.Provider,
            }),
        ),
    ),
};
